import { useEffect, useState } from "react";
import { cn } from "../../lib/utils";
import {
  bgHexMap,
  colorHexMap,
  colorMap,
  ColorType,
} from "../../shared/colors";
import { useInView } from "react-intersection-observer";

type CircularProgressProps = {
  title: string;
  value: number;
  color: ColorType;
  size?: number;
  pathWidth?: number;
};

const CircularProgress = ({
  title,
  value,
  color,
  size = 122,
  pathWidth = 6,
}: CircularProgressProps) => {
  const [counter, setCounter] = useState(0);
  const [done, setDone] = useState(false);
  const { ref: progressRef, inView: animate } = useInView();

  const startCount = () => {
    setDone(true);
    const interval = setInterval(() => {
      setCounter((p) => {
        const newCounter = p + 1;
        if (newCounter === value) {
          clearInterval(interval);
        }
        return newCounter;
      });
    }, 2000 / value);
  };

  useEffect(() => {
    if (animate && !done) {
      startCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animate, done]);

  if (size > 140) size = 140;
  else if (size < 100) size = 100;

  return (
    <div ref={progressRef}>
      <div
        className="rounded-full flex justify-center items-center duration-1000 transition-colors"
        style={{
          background: `conic-gradient(${colorHexMap[color]} ${
            counter * 3.6
          }deg, ${bgHexMap[color]} 0deg)`,
          width: size,
          height: size,
        }}
      >
        <div
          className={cn("absolute rounded-full ", "bg-[--background]")}
          style={{
            width: `calc(${size}px - ${pathWidth}px)`,
            height: `calc(${size}px - ${pathWidth}px)`,
          }}
        />

        <p className="relative m-0 text-center font-semibold flex flex-col gap-1">
          <span className="text-[--title] text-sm">{title}</span>
          <span className={cn("percentage text-md", colorMap[color])}>
            {counter}%
          </span>
        </p>
      </div>
    </div>
  );
};

export default CircularProgress;
